import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { Period } from '@/lib/timePeriod';
import type { GeoClustersResponse } from '@/types/fraudHub';

/**
 * Fetches station-centroid alert clusters for the Hub mini-map.
 *
 * Period-aware (PR 3): cluster window follows the selected period rather
 * than a hardcoded 7-day rolling.
 *
 * Returns `clusters: []` until the backend rule_engine starts populating
 * `station_id` on emitted alerts. The SPA renders a convincing empty
 * state in that case — no data churn needed when the population fix
 * lands.
 */
export function useFraudHubGeoClusters(
  period: Period,
): UseQueryResult<GeoClustersResponse, Error> {
  return useQuery<GeoClustersResponse, Error>({
    queryKey: ['fraud-hub', 'geo-clusters', period],
    queryFn: async () => {
      const { data } = await api.get<GeoClustersResponse>(
        '/fraud-hub/geo-clusters',
        { params: { period } },
      );
      return data;
    },
    staleTime: 30_000,
  });
}
